export default __webpack_public_path__ + "static/media/flag-es.83a50335.svg";